const React = require('react')
const { useState } = require('react')
const { useHistory } = require('react-router-dom')
const {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Collapse,
    FormGroup,
    Label,
    Input,
    UncontrolledTooltip,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} = require('reactstrap')

const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const AdvancedConfiguration = props => {
    const {
        optimization,
        setOptimization,
        optimizationRuns,
        setOptimizationRuns,
        evmVersion,
        setEvmVersion,
        licenseType,
        setLicenseType
    } = props
    const history = useHistory()
    const { network } = useNetworkConfig()

    const evmOptions = [
        'default (compiler defaults)',
        'homestead (oldest version)',
        'tangerineWhistle',
        'spuriousDragon',
        'byzantium (default for <= v0.5.4)',
        'constantinople',
        'petersburg (default for >= v0.5.5)',
        'istanbul (default for >= v0.5.14)',
        'berlin (default for >= v0.8.5)',
        'london (default for >= v0.8.7)',
        'paris (default for >=v0.8.18)',
        'shanghai (default for >=v0.8.20)',
        'cancun (default for >= v0.8.24)'
    ]

    const licenseOptions = [
        '1) No License (None)',
        '2) The Unlicense (Unlicense)',
        '3) MIT License (MIT)',
        '4) GNU General Public License v2.0 (GNU GPLv2)',
        '5) GNU General Public License v3.0 (GNU GPLv3)',
        '6) GNU Lesser General Public License v2.1 (GNU LGPLv2.1)',
        '7) GNU Lesser General Public License v3.0 (GNU LGPLv3)',
        '8) BSD 2-clause "Simplified" license (BSD-2-Clause)',
        '9) BSD 3-clause "New" Or "Revised" license (BSD-3-Clause)',
        '10) Mozilla Public License 2.0 (MPL-2.0)',
        '11) Open Software License 3.0 (OSL-3.0)',
        '12) Apache 2.0 (Apache-2.0)',
        '13) GNU Affero General Public License (GNU AGPLv3)',
        '14) Business Source License (BSL 1.1)'
    ]

    const [isAdvancedConfigurationOpen, setIsAdvancedConfigurationOpen] = useState(true)
    const [optimizationDropdownOpen, setOptimizationDropdownOpen] = useState(false)
    const [evmVersionsDropdownOpen, setEvmVersionsDropdownOpen] = useState(false)
    const [licenseDropdownOpen, setLicenseDropdownOpen] = useState(false)

    const handleOptimizationChange = value => {
        if (value === optimization) {
            setOptimizationDropdownOpen(false)
        } else {
            setOptimization(value)
        }
    }

    const handleOptimizationRunsChange = e => {
        const value = e.target.value
        setOptimizationRuns(value)
    }

    const handleEvmVersionChange = value => {
        if (value === evmVersion) {
            setEvmVersionsDropdownOpen(false)
        } else {
            setEvmVersion(value)
        }
    }

    const handleLicenseChange = license => {
        if (license === licenseType) {
            setLicenseDropdownOpen(false)
        } else {
            setLicenseType(license)
        }
    }

    return (
        <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
            <CardHeader
                className='verify-card-header cursor-pointer'
                onClick={() => setIsAdvancedConfigurationOpen(!isAdvancedConfigurationOpen)}
                style={{
                    border: !isAdvancedConfigurationOpen && 'none',
                    borderColor: isAdvancedConfigurationOpen && 'var(--dropdown-background)'
                }}
            >
                <span style={{ fontWeight: 'bold' }}>Advanced Configuration</span>
                <i className={`fas fa-angle-${isAdvancedConfigurationOpen ? 'up' : 'down'}`} />
            </CardHeader>
            <Collapse isOpen={isAdvancedConfigurationOpen}>
                <CardBody>
                    <Row>
                        <Col xs='6' xl='3'>
                            <FormGroup>
                                <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    Optimization
                                    <span
                                        id='optimization-tooltip'
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <i
                                            className='fas fa-circle-question'
                                            style={{
                                                fontSize: '14px',
                                                color: 'var(--grey-color)'
                                            }}
                                        />
                                        <UncontrolledTooltip placement='top' target='optimization-tooltip'>
                                            Select the option you used when compiling this contract.
                                        </UncontrolledTooltip>
                                    </span>
                                </Label>
                                <Dropdown
                                    isOpen={optimizationDropdownOpen}
                                    toggle={() => setOptimizationDropdownOpen(!optimizationDropdownOpen)}
                                    className='mb-3 w-100 dark-dropdown'
                                >
                                    <DropdownToggle caret className='form-dropdown-toggle'>
                                        <span>{optimization}</span>
                                    </DropdownToggle>
                                    <DropdownMenu className='w-100'>
                                        {['Yes', 'No'].map(option => (
                                            <DropdownItem
                                                className={`${network.name}-dropdown-item`}
                                                key={option}
                                                onClick={() => handleOptimizationChange(option)}
                                            >
                                                {option}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </FormGroup>
                        </Col>
                        <Col xs='6' xl='3'>
                            <FormGroup>
                                <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    Runs (Optimizer)
                                    <span
                                        id='runs-tooltip'
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <i
                                            className='fas fa-circle-question'
                                            style={{
                                                fontSize: '14px',
                                                color: 'var(--grey-color)'
                                            }}
                                        />
                                        <UncontrolledTooltip placement='top' target='runs-tooltip'>
                                            (Applicable when Optimization = Yes) optimize for how many times you intend
                                            to run the code. Lower values will optimize more for initial deployment
                                            code, higher values will optimize more for high-frequency usage.
                                        </UncontrolledTooltip>
                                    </span>
                                </Label>
                                <Input
                                    type='text'
                                    className='mb-3'
                                    value={optimizationRuns}
                                    onChange={handleOptimizationRunsChange}
                                    style={{
                                        backgroundColor: 'var(--dropdown-background)',
                                        color: 'var(--white-color)',
                                        border: 'none'
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs='12' xl='6'>
                            <FormGroup>
                                <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    EVM Version to target
                                    <span
                                        id='evm-version-tooltip'
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <i
                                            className='fas fa-circle-question'
                                            style={{
                                                fontSize: '14px',
                                                color: 'var(--grey-color)'
                                            }}
                                        />
                                        <UncontrolledTooltip placement='top' target='evm-version-tooltip'>
                                            When you compile your contract code you can specify the Ethereum virtual
                                            machine version to compile for to avoid particular features or behaviours.
                                        </UncontrolledTooltip>
                                    </span>
                                </Label>
                                <Dropdown
                                    isOpen={evmVersionsDropdownOpen}
                                    toggle={() => setEvmVersionsDropdownOpen(!evmVersionsDropdownOpen)}
                                    className='mb-3 w-100 dark-dropdown'
                                >
                                    <DropdownToggle caret className='form-dropdown-toggle'>
                                        <span>{evmVersion}</span>
                                    </DropdownToggle>
                                    <DropdownMenu className='w-100'>
                                        {evmOptions.map(option => (
                                            <DropdownItem
                                                className={`${network.name}-dropdown-item`}
                                                key={option}
                                                onClick={() => handleEvmVersionChange(option)}
                                            >
                                                {option}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs='12' xl='6'>
                            <FormGroup>
                                <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    License Type&nbsp;
                                    <span>
                                        <i
                                            id='license-tooltip'
                                            className={`${network.name}-text-color fas fa-info-circle cursor-pointer`}
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                            onClick={() => history.push(`/${network.name}/contract-license-types`)}
                                        />
                                        <UncontrolledTooltip placement='top' target='license-tooltip'>
                                            Contract Source Code License Type, click for more info.
                                        </UncontrolledTooltip>
                                    </span>
                                </Label>
                                <Dropdown
                                    isOpen={licenseDropdownOpen}
                                    toggle={() => setLicenseDropdownOpen(!licenseDropdownOpen)}
                                    className='mb-3 w-100 dark-dropdown'
                                >
                                    <DropdownToggle caret className='form-dropdown-toggle'>
                                        <span>{licenseOptions[licenseType - 1]}</span>
                                    </DropdownToggle>
                                    <DropdownMenu className='w-100'>
                                        {licenseOptions.map((option, index) => (
                                            <DropdownItem
                                                className={`${network.name}-dropdown-item`}
                                                onClick={() => handleLicenseChange(index + 1)}
                                            >
                                                {option}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </FormGroup>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </Card>
    )
}

module.exports = { AdvancedConfiguration }
